import AclName from '../../../../acl/AclName.js';
import action from '../../../abstract/action.js';

export default action({
  label: 'Numeracja',
  icon: 'SlidersIcon',
  acl: AclName.SettingsBtnInvoiceTemplateNumberChangeNumber,
  main: () => true,
  handle: async ({ $router, item: { id } }) => await $router.push({
    name: 'invoices-number-templates-start-number',
    params: {
      id,
    },
  }),
});
